/**
 * Paleta cíclica de cores por módulo, mapeada para classes de token Tailwind
 * (sem hex inline — ver decisão D5 do design). O índice do módulo escolhe a classe.
 */
const MODULE_BG_CLASSES = [
  'bg-base-brand-600',
  'bg-base-accent-500',
  'bg-base-success-600',
  'bg-base-warning-600',
  'bg-base-gray-500',
  'bg-base-accent-700',
  'bg-base-success-700',
  'bg-base-warning-700',
] as const;

/** Classe de background para "sem módulo" (cinza neutro). */
export const NO_MODULE_BG_CLASS = 'bg-base-gray-400';

/**
 * Classe de background do token para o módulo na posição `index` (cíclica).
 *
 * @param index - Índice do módulo na lista; `-1`/ausente → cor de "sem módulo".
 */
export function moduleColorClass(index: number): string {
  if (index < 0) return NO_MODULE_BG_CLASS;
  return MODULE_BG_CLASSES[index % MODULE_BG_CLASSES.length] ?? NO_MODULE_BG_CLASS;
}
